import React, { useState } from "react";
import { Link } from "react-router-dom";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import Icon from "@/components/Icon";
import QRPreview from "@/components/QRPreview";
import PhoneMockup from "@/components/PhoneMockup";
import ScanResult from "@/components/ScanResult";
import { DESTINATIONS } from "@/lib/qr";

const SAMPLE = {
  vcard: { first_name: "John", last_name: "Smith", prefix: "Mr.", job_title: "Product Lead", company: "QR Code Creator Studio", mobile: "+1 555 200 1234", email: "john@qrcodecreatorstudio.com", website: "https://qrcodecreatorstudio.com", instagram: "https://instagram.com/qr-code-creator-studio", linkedin: "https://linkedin.com/in/qr-code-creator-studio" },
  menu: { title: "Bistro Nord", sections: [{ name: "Starters", items: [{ name: "Truffle Fries", price: "$8" }, { name: "Burrata", price: "$12" }] }, { name: "Mains", items: [{ name: "Ribeye", price: "$28" }, { name: "Sea Bass", price: "$24", available: false }] }] },
  coupon: { title: "Grand Opening", discount: "25% OFF", description: "On your first order", code: "WELCOME25", expiry: "2026-12-31" },
  event: { title: "Product Launch 2026", date: "2026-10-12", time: "18:00", venue: "Skyline Hall, NYC", description: "Join us for the reveal." },
  business_page: { name: "QR Code Creator Studio Studio", tagline: "Design agency", description: "We craft brands & experiences.", hours: "Mon-Fri 9-6", phone: "+1 555 900 1000", website: "https://qrcodecreatorstudio.com", address: "500 Market St, SF" },
  social_media: { title: "Follow QR Code Creator Studio", links: [{ platform: "Instagram", url: "#" }, { platform: "LinkedIn", url: "#" }, { platform: "YouTube", url: "#" }] },
  rating: { title: "Rate your visit" },
};

const DESIGNS = {
  vcard: { fg: "#0B0F17", dotType: "rounded", cornerDotColor: "#6366F1", useCustomCorners: true, cornerSquareColor: "#0B0F17" },
  menu: { fg: "#7C2D12", bg: "#FFF7ED", dotType: "classy-rounded" },
  coupon: { fg: "#E11D48", dotType: "dots" },
  event: { fg: "#4F46E5", dotType: "extra-rounded", useGradient: true, gradientColor: "#06B6D4" },
  business_page: { fg: "#064E3B", dotType: "rounded" },
  social_media: { fg: "#8B5CF6", dotType: "dots" },
  rating: { fg: "#F59E0B", dotType: "rounded" },
};

export default function Examples() {
  const keys = Object.keys(SAMPLE);
  const [active, setActive] = useState("vcard");
  const meta = DESTINATIONS.find((d) => d.id === active);
  return (
    <div className="min-h-screen bg-background">
      <PublicHeader />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <h1 className="text-4xl sm:text-5xl font-display font-extrabold tracking-tight text-center">Examples & templates</h1>
        <p className="text-muted-foreground mt-4 text-center max-w-xl mx-auto">Tap a template to preview the exact scan result on a phone.</p>
        <div className="flex flex-wrap gap-2 justify-center mt-8">
          {keys.map((k) => { const m = DESTINATIONS.find((d) => d.id === k); return (
            <button key={k} data-testid={`example-${k}`} onClick={() => setActive(k)} className={`px-4 py-2 rounded-xl text-sm font-semibold border transition-colors flex items-center gap-2 ${active === k ? "border-primary bg-primary text-primary-foreground" : "border-border hover:bg-accent"}`}><Icon name={m.icon} className="h-4 w-4" />{m.name}</button>); })}
        </div>
        <div className="grid lg:grid-cols-2 gap-10 mt-12 items-center">
          <div className="flex justify-center">
            <div className="rounded-3xl border border-border bg-card p-8 shadow-xl" style={{ width: 300 }}>
              <QRPreview design={{ ...DESIGNS[active], size: 240 }} data={`https://qrcodecreatorstudio.com/p/${active}`} />
              <div className="mt-4 flex items-center gap-2"><Icon name={meta.icon} className="h-5 w-5 text-primary" /><span className="font-semibold text-sm">{meta.name}</span></div>
            </div>
          </div>
          <div className="flex justify-center">
            <PhoneMockup><ScanResult type={active} data={SAMPLE[active]} company={{ name: "QR Code Creator Studio" }} live /></PhoneMockup>
          </div>
        </div>
        <div className="text-center mt-12"><Link to="/register" className="rounded-xl bg-primary text-primary-foreground px-6 py-3 text-sm font-bold hover:opacity-90 inline-flex items-center gap-2">Build your own <Icon name="ArrowRight" className="h-4 w-4" /></Link></div>
      </section>
      <PublicFooter />
    </div>
  );
}